import {
  ORDER_AGGREGATORS_REQUEST,
  ORDER_AGGREGATORS_BANK_TRANSFER_REQUEST,
  ORDER_AGGREGATORS_REQUEST_ERROR_MESSAGE
} from 'constants/action-types';

export const postOrderAggregators = data => ({
  type: ORDER_AGGREGATORS_REQUEST,
  payload: {
    request: {
      url: 'selling/order-aggregators',
      method: 'POST',
      headers: {
        'Cache-Control': 'no-cache'
      },
      data
    }
  }
});

export const postOrderAggregatorsBankTransfer = data => ({
  type: ORDER_AGGREGATORS_BANK_TRANSFER_REQUEST,
  payload: {
    request: {
      url: 'selling/order-aggregators/bank-transfer',
      method: 'POST',
      headers: {
        'Cache-Control': 'no-cache'
      },
      data
    }
  }
});

export const getOrderAggregatorsError = projectId => {
  return {
    type: ORDER_AGGREGATORS_REQUEST_ERROR_MESSAGE,
    payload: {
      request: {
        url: 'selling/order-aggregators/error-message',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        },
        params: {
          projectId
        }
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/orderAggregators/confirmation.js